'use strict';
const _ = require('lodash');
// const $ = require('jquery');
const Backbone = require('backbone');
const PubSub = require('../PubSub'); 
// const ViewShare = require('./share');
const template = require('../templates/poll.ejs');
const CmsModel = require('@telescope/tscom-cms');
const ConnectModel = require('tscom-connect');
const StorageModel = require('./../models/storage');

// const REGEX = require('../constants').REGEX;

module.exports = Backbone.View.extend({
    className: 'view-poll',
    events: { 
        'click .btn-close': 'closeModal',
        'click .mtv-close': 'routeMTVLink',
        'click .btn-poll': 'onPollAnswer',
        'click a': 'handleAnchorClick'
    },
    /**
     *
     */
    initialize: function (options) {
        _.bindAll(this, 'render', 'closeModal');

        options = options || {};

        this.getContextData = options.getContextData;
        this.getUserData = options.getUserData;
        this.completed = false;

        this.userModel = options.userModel;
        this.model = new CmsModel({
          id: 'pollcms',
          wid: options.pollWidgetId
        },{
            ignoreQSP: true
        });
        this.model.poll = false;

        this.storage = new StorageModel({ storageMethod: 'cookie' });

        this.listenTo( this.model, 'change:cookieReady', this.render );

        this.model.fetch().then( function() {
          this.completed = this.readCookie();

          const settings = this.model.get('settings');
          this.connect = new ConnectModel( { apiKey: settings.apiKey }, { version_id: settings.version_id } );
          this.connect.versionCheck = 'llkipqojlkjasdlkzjkaj';

        }.bind(this) );
    },

    getKey: function() {
      const userData = this.getUserData();
      const key = userData.user_id + this.model.get('wid') + this.model.get('data')[0].reporting_identifier;
      return key;
    },

    readCookie: function() {
      const key = this.getKey();

      if(window.cbsoptanon) {
        window.cbsoptanon.cmd.push(function(cmp) {
          cmp.ot.functionalAllowed( function(allowed) {
            if( allowed ) { 
              this.completed = this.storage.fetch( key );
            } 
            this.model.set( 'cookieReady', true );
          }.bind(this));
        }.bind(this));
      }
    },

    saveCookie: function() {
      const key = this.getKey();

      if(window.cbsoptanon) {
        window.cbsoptanon.cmd.push(function(cmp) {
          cmp.ot.functionalAllowed( function(allowed) {
            if( allowed ) {
              this.storage.save( key, true, 180 );
            }
          }.bind(this));
        }.bind(this));
      }
    },

    onPollAnswer: function(evt) {
      const question = this.model.get('data')[0];
      const answers = question.answers;
      const answer = evt.currentTarget.textContent;
      const answerIndex = answers.indexOf( answer );
      
      if( answerIndex > -1 ) {
        
        const id = String.fromCharCode( 65 + answerIndex );
        const data = _.extend(
          {
            v: id,
            action_type: 'vote',
            sid: question.reporting_identifier,
            real_name: answer
          },
          this.getUserData(),
          this.getContextData()
        );
        
        var omParams = { name: 'poll answer button', section: 'poll-modal', url: window.location.href };
        var gaParams = { eventCategory: 'Button Click', eventAction: 'Submit Poll' };

        PubSub.trigger('linkClick', omParams, gaParams);

        this.connect.save( data )
          .then( function( ) {
            this.completed = true;
            this.saveCookie();
            this.render();
          }.bind(this));

      }
    },
    /**
     *
     */
    render: function () {
        if( this.model.get('initialized') ) {
          this.$el.html(template(
            _.extend(
              { completed: this.completed },
              this.model.toJSON()
            )
          ));
        }
        return this;
    },
    /**
     * [closeModal description]
     * @return {[type]} [description]
     */
    closeModal: function(e) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        PubSub.trigger('navigate', 'thanks');
    }
});


// WEBPACK FOOTER //
// ./app/scripts/views/poll.js